import Api from "../Helpers/Api";

class AdministratorsService {
  getAdministrators() {
    return Api.get(`/administradores`);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AdministratorsService();